module.exports = __webpack_public_path__ + "c3268ca84878e012b1a0bd83720060f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/animareal.png
// module id = 69
// module chunks = 0